import { $api } from "../http";

interface DeliverySettingsData {
  id: number;
  isDeliveryEnabled: boolean;
  isEnabled: boolean;
  basePrice: number;
  pricePerKm: number;
  freeDeliveryFrom: number | null;
  minOrderValue: number;
  deliveryCloseHour: string | null;
  createdAt: string;
  updatedAt: string;
}

export default class RestaurantService {
  static async getDeliveryStatus(): Promise<DeliverySettingsData | null> {
    try {
      const response = await $api.get<DeliverySettingsData>("/delivery/settings");

      return response?.data ?? null;
    } catch (error) {
      console.error("Failed to fetch delivery status:", error);
  
      return null;
    }
  }

  static async updateDeliveryStatus(isEnabled: boolean): Promise<DeliverySettingsData> {
    const response = await $api.patch<DeliverySettingsData>('/delivery/settings', { 
      isDeliveryEnabled: isEnabled 
    }); 

    return response.data;
  }
}

